import {toNumber} from '@yandex-delivery/utils'
import {Counter as CounterBase} from '@yandex-delivery/blocks'
import React, {ChangeEventHandler, useCallback} from 'react'
import {useController, useFormContext, useWatch} from 'react-hook-form'

import {scoped} from '../../utils/scoped'
import {Props} from './Counter.types'

/** @deprecated use `import {NumberCounter} from '@yandex-delivery/form'` */
export function Counter({
  name,
  rules,
  defaultValue,
  shouldUnregister,
  ...otherProps
}: Props): React.ReactElement<Props> {
  const {control} = useFormContext()
  const {
    field: {value: fieldValue, onChange, onBlur},
    fieldState: {error},
  } = useController({control, name, rules, shouldUnregister})
  const value = useWatch({name, defaultValue: fieldValue})

  const changeHandler = useCallback<ChangeEventHandler<HTMLInputElement>>(
    event => {
      onChange(toNumber(event.target.value))
      onBlur()
    },
    [onBlur, onChange],
  )

  return (
    <CounterBase
      error={Boolean(error)}
      name={name}
      onBlur={onBlur}
      onChange={changeHandler}
      value={value ?? defaultValue}
      {...otherProps}
    />
  )
}

export const ScopedCounter = scoped(CounterBase)
